import { StaticTimeFilterType } from './StaticTimeFilterType';
import { StaticTimeFilter } from './StaticTimeFilter';

export default StaticTimeFilter;
export { StaticTimeFilterType };
